'use client';

import a__default, { useRef, useEffect } from "react";
import { Text } from "../../../atoms/Text/Text.js";
import { useId } from "../../../utils/hooks/useId.js";
import { focusMockLabel } from "../InlineNotification.data.js";
function FocusMockOnHide({
  children,
  isHidden
}) {
  const id = useId();
  const focusMockRef = useRef(null);
  useEffect(() => {
    var _a;
    if (isHidden) (_a = focusMockRef.current) == null ? void 0 : _a.focus();
  }, [isHidden]);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
    Text,
    {
      "aria-hidden": "true",
      "aria-labelledby": id,
      ref: focusMockRef,
      role: "group",
      tabIndex: -1,
      visuallyHidden: true
    },
    /* @__PURE__ */ a__default.createElement(Text, { id, visuallyHidden: true }, focusMockLabel)
  ), !isHidden && children);
}
export {
  FocusMockOnHide
};
